import { render, staticRenderFns } from "./ModuleListComponent.vue?vue&type=template&id=5fb3b66c&scoped=true&"
import script from "./ModuleListComponent.vue?vue&type=script&lang=js&"
export * from "./ModuleListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModuleListComponent.vue?vue&type=style&index=0&id=5fb3b66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb3b66c",
  null
  
)

export default component.exports